// extracted by mini-css-extract-plugin
export default {"glowBackground":"HeadlessWoocom_glowBackground__EV9pm","woocomReact":"HeadlessWoocom_woocomReact__RvwaJ"};